/* @ngInject */
//@ts-check
import { serverfyJSObject } from '../../../common/common';

export default class ProfileCtrl {
    constructor(
        $sce,
        $scope,
        $timeout,
        $rootScope,
        ProfileService,
        UserUnitsService,
        BuildingsService,
        NavigationService,
        NotificationService,
        LocalStorageService,
        CountriesUtilService
    ) {
        this.$sce = $sce;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.ProfileService = ProfileService;
        this.UserUnitsService = UserUnitsService;
        this.BuildingsService = BuildingsService;
        this.NavigationService = NavigationService;
        this.NotificationService = NotificationService;
        this.LocalStorageService = LocalStorageService;
        this.CountriesUtilService = CountriesUtilService;

        this.init();
        this.activate();
    }

    async init() {
        this.isBusy = true;
        this.unitList = null;

        this.emailIndex = null;
        this.emailAction = null;

        this.isEditingMobile = false;
        this.selectedCardCode = null;
        this.isEditingDetails = false;
        this.details = {
            address: {
                lineOne: null,
                lineTwo: null,
                lineThree: null,
                lineFour: null,
                postalCode: null
            },
            userName: null,
            lastName: null,
            firstName: null,
            homeNumber: null,
            cellNumber: null,
            workNumber: null,
            idOrPassportNumber: null,
            emailAddresses: null
        };

        this.isEditContactInfo = false;
        this.isEditAddressInfo = false;
        this.contactInformation = null;
        this.addressInformation = null;

        this.updatableCellphone = undefined;

        this.selectedHomeNumber = undefined;
        this.isEditingHomePhoneNumber = false;
        this.updatableHomePhoneNumber = undefined;

        this.selectedWorkNumber = undefined;
        this.isEditingWorkPhoneNumber = false;
        this.updatableWorkPhoneNumber = undefined;

        this.lockEmailAddress = false;
        this.isEditingEmailAddress = false;
        this.updatableEmailAddress = undefined;

        this.confirmChangeModal = undefined;
        this.multipleUnitChangeModal = undefined;
        this._handleEvents();
    }

    get getOwnerId() {
        const { FirstId, AdditionalId } = this.ProfileService.myProfileInformation;
        const fields = [FirstId, AdditionalId];

        const mappedIds = fields.map(field => {
            let mapped;
            if (!!field) {
                mapped = `<span class="value">${field},</span>`;
                return mapped;
            }
        });

        return this.$sce.getTrustedHtml(mappedIds.join(''));
    }

    get getResidentialAddress() {
        const {
            AddressLine1,
            AddressLine2,
            AddressLine3,
            AddressLine4,
            PostalCode
        } = this.ProfileService.myProfileInformation;
        const fields = [
            AddressLine1,
            AddressLine2,
            AddressLine3,
            AddressLine4,
            PostalCode
        ];
        const add = fields.map(field => {
            let mapped;
            if (!!field) {
                mapped = `<span class="value">${field},</span>`;
                return mapped;
            }
        });

        const html = this.$sce.getTrustedHtml(add);
        const addressFields = html.split('</span>,');
        const mappedFields = addressFields.map((field, i) => {
            let mappedField = field;

            if (!field.endsWith('</span>')) {
                mappedField = `${field}</span>`;
            }

            if (i === addressFields.length - 1) {
                mappedField = mappedField.replace(',', '');
            }

            return mappedField;
        });

        const trustedHtml = mappedFields.join('');

        return trustedHtml;
    }

    get getHomeNumber() {
        const { HomeNumber } = this.ProfileService.myProfileInformation;
        const mappedHomeNumber = HomeNumber.join('<br />');

        return this.$sce.getTrustedHtml(mappedHomeNumber);
    }

    get getCellNumber() {
        const { CellPhoneNumber } = this.ProfileService.myProfileInformation;
        const mappedCellNumber = CellPhoneNumber.join('<br />');

        return this.$sce.getTrustedHtml(mappedCellNumber);
    }

    get getUserName() {
        const { EmailAddress } = this.ProfileService.myProfileInformation;
        const mappedEmails = EmailAddress.join('<br />');
        this.details.emailAddresses = EmailAddress;
        return mappedEmails;
    }

    get getFirstName() {
        const { FirstName } = this.ProfileService.myProfileInformation;
        return FirstName;
    }

    get getLastName() {
        const { LastName } = this.ProfileService.myProfileInformation;
        return LastName;
    }

    setANewPassword() {

        this.$rootScope.$broadcast('user-reset-password');
    }

    editDetails() {
        this.isEditingDetails = true;

        const {
            FirstId,
            AdditionalId,
            LastName: lastName,
            FirstName: firstName,
            AddressLine1: lineOne,
            AddressLine2: lineTwo,
            HomeNumber: homeNumber,
            WorkNumber: workNumber,
            AddressLine4: lineFour,
            PostalCode: postalCode,
            EmailUserName: userName,
            AddressLine3: lineThree,
            CellPhoneNumber: cellNumber,
            EmailAddress: emailAddresses
        } = this.ProfileService.myProfileInformation;

        this.originalFirstEmail = emailAddresses[0];
        this.originalProfile = angular.copy(this.ProfileService.myProfileInformation);

        const idOrPassportNumber = `${FirstId}/${AdditionalId}`;

        this.details = {
            lastName,
            userName,
            firstName,
            homeNumber,
            cellNumber,
            workNumber,
            address: {
                lineOne,
                lineTwo,
                lineFour,
                lineThree,
                postalCode
            },
            idOrPassportNumber,
            emailAddresses
        };

        if (Array.isArray(this.details.cellNumber)) {
            this.details.cellNumber = this.details.cellNumber.join(',')
        }

        if (Array.isArray(this.details.homeNumber)) {
            this.details.homeNumber = this.details.homeNumber.join(',')
        }

        if (Array.isArray(this.details.workNumber)) {
            this.details.workNumber = this.details.workNumber.join(',')
        }
    }

    async saveDetails() {
        this.isBusy = true;
        this.isEditingDetails = false;

        try {
            let cardCode, schemeReference;
            if (
                !!this.selectedCardCode &&
                typeof this.selectedCardCode === 'string'
            ) {
                //TODO: START HERE...
                const temp = JSON.parse(this.selectedCardCode);
                const { SchemeReference: schemeRef, CardCode: incomingCardCode } = temp;
                cardCode = incomingCardCode;
                schemeReference = schemeRef;
                //this.selectedCardCode = JSON.parse(this.selectedCardCode);
            } else {
                const {
                    SchemeReference: schemeRef,
                    CardCode: incomingCardCode
                } = this.selectedCardCode;
                cardCode = incomingCardCode;
                schemeReference = schemeRef;
            }

            const { idOrPassportNumber } = this.details;
            let {
                lastName,
                userName,
                firstName,
                homeNumber,
                cellNumber,
                workNumber,
                address: {
                    postalCode,
                    lineOne: addressLine1,
                    lineTwo: addressLine2,
                    lineFour: addressLine4,
                    lineThree: addressLine3
                }
            } = this.details;

            if (!!homeNumber) {
                homeNumber = homeNumber.split(',');
            }

            if (!!cellNumber) {
                cellNumber = cellNumber.split(',');
            }

            if (!!workNumber) {
                workNumber = workNumber.split(',');
            }

            const joinAndTrim = (value, separator = '/') => {
                if (!value) return null;
                const joined = value.length > 1 ? value.join(separator) : value[0];
                return joined.endsWith(separator) ? joined.slice(0, -1) : joined;
            };

            var cellphoneString = this.ProfileService.myProfileInformation.CellPhoneNumber;
            var emailString = this.ProfileService.myProfileInformation.EmailAddress;
            let payload = serverfyJSObject({
                cardCode,
                lastName,
                firstName,
                postalCode,
                addressLine1,
                addressLine2,
                addressLine3,
                addressLine4,
                schemeReference,
                emailUserName: joinAndTrim(emailString, ';'),
                homeNumber: joinAndTrim(homeNumber),
                cellNumber: joinAndTrim(cellphoneString),
                workNumber: joinAndTrim(workNumber)
            });

            if (!!idOrPassportNumber && idOrPassportNumber.includes('/')) {
                const idFields = idOrPassportNumber.split('/');
                const FirstId = idFields[0],
                    AdditionalId = idFields[1];

                payload = {
                    ...payload,
                    FirstId,
                    AdditionalId
                };
            }

            await this.ProfileService.updateDetails(payload);

            const updatedFirstEmail = this.ProfileService.myProfileInformation.EmailAddress[0];
            const firstEmailChanged = (updatedFirstEmail ? updatedFirstEmail.toLowerCase() : '') !==
                (this.originalFirstEmail ? this.originalFirstEmail.toLowerCase() : '');

            if (firstEmailChanged) {
                $("#usernameChangedModal").modal('show');
            } else {
                this.activate();
                this.isBusy = false;
                window.location.reload();
            }
        } catch (error) {
            console.error(error);
            const msg = 'Error while saving your details.';
            this.NotificationService.error(msg);
        } finally {
            this.isBusy = false;
        }
    }

    switchEditContactDetails(flag) {
        this.isEditContactInfo = flag;

        if (!this.isEditContactInfo) {
            this.updatableCellphone = null;
            this.updatableEmailAddress = null;
            this.updatableHomePhoneNumber = null;
            this.updatableWorkPhoneNumber = null;
        } else {
            this.switchEditAddress(false);
        }
    }

    applyChangesToAllUnits() { }

    switchEditAddress(flag) {
        this.isEditAddressInfo = flag;
        if (this.isEditAddressInfo) {
            this.switchEditContactDetails(false);
        }
    }

    async _setInitialUnitInfo() {
        let selectedBuildingRefObj;
        const selectedBuildingRef = this.LocalStorageService.retrieve(
            'selectedBuildingRef'
        );
        if (typeof selectedBuildingRef !== 'object') {
            const user = this.LocalStorageService.retrieve('userProfile');
            if (user) {
                const { BuildingProfiles } = user;
                if (BuildingProfiles) {
                    const {
                        SchemeName,
                        SchemeReference,
                        BuildingProfileUnit
                    } = BuildingProfiles[0];
                    const { CardCode } = BuildingProfileUnit[0];
                    selectedBuildingRefObj = {
                        CardCode,
                        SchemeName,
                        SchemeReference
                    };
                }
            }
        } else {
            selectedBuildingRefObj = selectedBuildingRef;
        }

        if (
            !!selectedBuildingRefObj &&
            this.selectedCardCode.CardCode !== selectedBuildingRefObj.CardCode
        ) {
            this.selectedCardCode = selectedBuildingRefObj;
        }
    }

    async activate() {
        await this.getUnits();
    }

    async _onSelectedBuildingChanged(event, schemeRef) {
        try {
            if (schemeRef) {
                this.activate();
            }
        } catch (err) {
            console.error('Error while loading user units:', err);
        } finally {
            this.isBusy = false;
        }
    }

    async getUnits() {
        this.isBusy = true;

        this.$timeout(async () => {
            try {
                const selectedBuilding = this.selectedBuilding;
                this.unitList = await this.UserUnitsService.getFriendlyUnitNames();

                this.unitList = this.unitList.filter(unit => {
                    let found = false;
                    const { CardCode: cardCode } = unit;
                    if (!!cardCode) {
                        const extractedSchemeRef = cardCode.substr(1, 3);
                        const { SchemeReference: selectedBuildingRef } = selectedBuilding;
                        if (extractedSchemeRef === selectedBuildingRef) {
                            found = true;
                        }
                    }

                    return found;
                });

                if (this.unitList && this.unitList.length > 0) {
                    const defaultUnit = this.unitList[0];
                    delete defaultUnit.$$hashKey;
                    const json = JSON.stringify(defaultUnit);

                    this.selectedCardCode = `${json}`;
                }
            } catch (err) {
                console.error('Error while loading user units:', err);
            } finally {
                await this.getMyProfileInformation();
                this.isBusy = false;
            }
        });
    }

    _setProfileInfo() {
        this._setAddressInfo();
        this._setContactInfo();
    }

    _setAddressInfo() {
        const {
            PostalCode,
            AddressLine1,
            AddressLine2,
            AddressLine3,
            AddressLine4
        } = this.ProfileService.myProfileInformation;

        this.addressInformation = {
            PostalCode,
            AddressLine1,
            AddressLine2,
            AddressLine3,
            AddressLine4
        };

        this.switchEditAddress(false);
    }

    resetAddressInfo() {
        this._setAddressInfo();
        this.switchEditAddress(false);
    }

    resetContactInfo() {
        this._setContactInfo();
        this.switchEditContactDetails(false);
    }

    _setContactInfo() {
        let {
            CardCode,
            HomeNumber,
            WorkNumber,
            EmailAddress,
            CellPhoneNumber,
            EmailAddressChanges
        } = this.ProfileService.myProfileInformation;

        HomeNumber = HomeNumber.filter(home => home && home.trim());
        WorkNumber = WorkNumber.filter(work => work && work.trim());
        EmailAddress = EmailAddress.filter(email => email && email.trim());
        CellPhoneNumber = CellPhoneNumber.filter(cell => cell && cell.trim());

        this.contactInformation = {
            CardCode,
            HomeNumber,
            WorkNumber,
            EmailAddress,
            CellPhoneNumber,
            EmailAddressChanges,
            selectedWorkNumber: '',
            selectedHomeNumber: '',
            selectedEmailAddress: '',
            selectedCellphoneNumber: ''
        };
    }

    shouldLogoutUser() {
        angular.element('#usernameChangedModal').modal('toggle');
        setTimeout(() => {
            window.location.href = '/';
        }, 5000);
    }

    _handleEvents() {
        this.$scope.$watch(
            'ProfileVM.selectedCardCode',
            (newValue, oldValue) => {
                if (this.selectedCardCode) {
                    this.getMyProfileInformation();
                }
            },
            true
        );

        this.$scope.$on('selected-building-changed', (event, newValue) => {
            this._onSelectedBuildingChanged(event, newValue);
        });

        this.$rootScope.$on('show-success-modal', (evt, msg) => {
            this.shouldLogoutUser();
        });

        angular.element('#usernameChangedModal').on('hidden.bs.modal', () => {
            angular.element('#userMenuItems li:last-child a').trigger('click');
        });

        this.$rootScope.$on('auth-modal-shown', (event, data) => {
            const $resetPasswordModal = angular.element(data[0]);
            const $passwordResetButton = angular.element(
                'button',
                $resetPasswordModal
            );
            const $passwordInput = angular.element(
                'input[ng-model="AuthVM.UserName"]',
                $resetPasswordModal
            );
            const userProfile = this.LocalStorageService.retrieve('userProfile');
            let { WebUsername: username, UserName: masterEmail } = userProfile;

            $passwordInput.prop('disabled', 'disabled');
            $passwordResetButton.removeAttr('disabled');

            if (!!!username) {
                username = masterEmail;
            }

            this.$rootScope.$broadcast('auth-modal-set-username', username);
        });

        this.$timeout(() => {
            const $resetPasswordModal = angular.element(
                'auth-modal[show-modal="AuthVM.showForgotPasswordModal"]'
            );
            $resetPasswordModal.on('shown.bs.modal', () => {
                const $passwordInput = angular.element('input', $resetPasswordModal);
                const userProfile = this.LocalStorageService.retrieve('userProfile');
                const { WebUsername: username } = userProfile;

                $passwordInput.value(username);
                $passwordInput.css('disabled', 'disabled');
            });

            $resetPasswordModal.on('hidden.bs.modal', () => {
                angular.element('.modal-backdrop.in').hide();
            });
        }, 8000);
    }

    addEditCellNumber() {
        if (this.updatableCellphone) {
            if (
                this.contactInformation.selectedCellphoneNumber &&
                this.contactInformation.selectedCellphoneNumber.length > 8
            ) {
                this.contactInformation.CellPhoneNumber[
                    this.updatableCellphone.index
                ] = this.contactInformation.selectedCellphoneNumber.trim();
            }
        } else {
            const oldNumber = this.contactInformation.CellPhoneNumber.find(
                mobileNo =>
                    mobileNo.trim() ===
                    this.contactInformation.selectedCellphoneNumber.trim()
            );

            if (!oldNumber) {
                if (
                    this.contactInformation.selectedCellphoneNumber &&
                    this.contactInformation.selectedCellphoneNumber.length > 8
                ) {
                    this.contactInformation.CellPhoneNumber = [
                        this.contactInformation.selectedCellphoneNumber,
                        ...this.contactInformation.CellPhoneNumber
                    ];
                }
            } else {
                this.NotificationService.error('Cellphone number already exists.');
            }
        }

        this.updatableCellphone = undefined;
        this.contactInformation.selectedCellphoneNumber = '';
    }

    editCellPhone(cellphoneIndex) {
        if (cellphoneIndex !== -1) {
            const oldNumber = this.contactInformation.CellPhoneNumber[cellphoneIndex];

            if (oldNumber) {
                this.updatableCellphone = {
                    number: oldNumber,
                    index: cellphoneIndex
                };
                this.contactInformation.selectedCellphoneNumber = oldNumber;
            } else {
                this.NotificationService.error(
                    'Cannot find the selected Cellphone number.'
                );
            }
        }
    }

    removeCellPhone(index, form) {
        this.contactInformation.CellPhoneNumber = this.contactInformation.CellPhoneNumber.filter(
            (phone, i) => i !== index
        );

        form.$setDirty();
    }

    addEditHomeNumber() {
        if (this.updatableHomePhoneNumber) {
            if (
                this.contactInformation.selectedHomeNumber &&
                this.contactInformation.selectedHomeNumber.length > 8
            ) {
                this.contactInformation.HomeNumber[
                    this.updatableHomePhoneNumber.index
                ] = this.contactInformation.selectedHomeNumber.trim();
            }
        } else {
            const oldNumber = this.contactInformation.HomeNumber.find(
                homePhoneNo =>
                    homePhoneNo.trim() ===
                    this.contactInformation.selectedHomeNumber.trim()
            );

            if (!oldNumber) {
                if (
                    this.contactInformation.selectedHomeNumber &&
                    this.contactInformation.selectedHomeNumber.length > 8
                ) {
                    this.contactInformation.HomeNumber = [
                        this.contactInformation.selectedHomeNumber,
                        ...this.contactInformation.HomeNumber
                    ];
                }
            } else {
                this.NotificationService.error('Home phone number already exists.');
            }
        }

        this.updatableHomePhoneNumber = undefined;
        this.contactInformation.selectedHomeNumber = '';
    }

    editHomePhoneNumber(homePhoneNumberIndex) {
        if (homePhoneNumberIndex !== -1) {
            const oldNumber = this.contactInformation.HomeNumber[
                homePhoneNumberIndex
            ];

            if (oldNumber) {
                this.updatableHomePhoneNumber = {
                    number: oldNumber,
                    index: homePhoneNumberIndex
                };
                this.contactInformation.selectedHomeNumber = oldNumber;
            } else {
                this.NotificationService.error(
                    'Cannot find the selected Home phone number.'
                );
            }
        }
    }

    removeHomePhoneNumber(index, form) {
        this.contactInformation.HomeNumber = this.contactInformation.HomeNumber.filter(
            (phone, i) => i !== index
        );

        form.$setDirty();
    }

    addEditWorkNumber() {
        if (this.updatableWorkPhoneNumber) {
            if (
                this.contactInformation.selectedWorkNumber &&
                this.contactInformation.selectedWorkNumber.length > 8
            ) {
                this.contactInformation.WorkNumber[
                    this.updatableWorkPhoneNumber.index
                ] = this.contactInformation.selectedWorkNumber.trim();
            }

            this.updatableWorkPhoneNumber = undefined;
        } else {
            const oldNumber = this.contactInformation.WorkNumber.find(
                homePhoneNo =>
                    homePhoneNo.trim() ===
                    this.contactInformation.selectedWorkNumber.trim()
            );

            if (!oldNumber) {
                if (
                    this.contactInformation.selectedWorkNumber &&
                    this.contactInformation.selectedWorkNumber.length > 8
                ) {
                    this.contactInformation.WorkNumber = [
                        this.contactInformation.selectedWorkNumber,
                        ...this.contactInformation.WorkNumber
                    ];
                }
            } else {
                this.NotificationService.error('Work phone number already exists.');
            }
        }

        this.updatableWorkPhoneNumber = undefined;
        this.contactInformation.selectedWorkNumber = '';
    }

    editWorkPhoneNumber(WorkPhoneNumberIndex) {
        if (WorkPhoneNumberIndex !== -1) {
            const oldNumber = this.contactInformation.WorkNumber[
                WorkPhoneNumberIndex
            ];

            if (oldNumber) {
                this.updatableWorkPhoneNumber = {
                    number: oldNumber,
                    index: WorkPhoneNumberIndex
                };
                this.contactInformation.selectedWorkNumber = oldNumber;
            } else {
                this.NotificationService.error(
                    'Cannot find the selected Work phone number.'
                );
            }
        }
    }

    removeWorkPhoneNumber(index, form) {
        this.contactInformation.WorkNumber = this.contactInformation.WorkNumber.filter(
            (phone, i) => i !== index
        );

        form.$setDirty();
    }

    editEmail(emailIndex, form) {
        if (emailIndex > -1) {
            const oldEmailAddress = this.contactInformation.EmailAddress[emailIndex];

            if (oldEmailAddress) {
                this.updatableEmailAddress = {
                    index: emailIndex,
                    address: oldEmailAddress
                };

                this.isEditingEmailAddress = true;
                this.contactInformation.selectedEmailAddress = oldEmailAddress;
            } else {
                this.NotificationService.error(
                    'Cannot find the selected Email Address.'
                );
            }
        }
    }

    removeEmail(index, form) {

        this.contactInformation.EmailAddress = this.contactInformation.EmailAddress.filter(
            (email, i) => i !== index
        );
        form.$setDirty();
    }

    addEditEmailAddress() {
        if (this.updatableEmailAddress) {
            if (
                this.contactInformation.selectedEmailAddress &&
                this.contactInformation.selectedEmailAddress.length > 2
            ) {
                this.isEditingEmailAddress = false;
                const { index } = this.updatableEmailAddress;
                this.contactInformation.EmailAddress[
                    index
                ] = this.contactInformation.selectedEmailAddress.trim();
            }
        } else {
            const oldEmail = this.contactInformation.EmailAddress.find(
                email =>
                    email.trim() === this.contactInformation.selectedEmailAddress.trim()
            );

            if (!oldEmail) {
                if (this.contactInformation.selectedEmailAddress) {
                    this.contactInformation.EmailAddress = [
                        this.contactInformation.selectedEmailAddress,
                        ...this.contactInformation.EmailAddress
                    ];
                }
            } else {
                this.NotificationService.error(
                    'Cannot find the selected Email Address.'
                );
            }
        }

        this.updatableEmailAddress = undefined;
        this.contactInformation.selectedEmailAddress = '';
    }

    get canAddEmail() {
        let canAdd = false;

        const { EmailAddress } = this.contactInformation;
        let emails = EmailAddress.join(';');
        if (
            !!!this.updatableEmailAddress &&
            this.contactInformation.selectedEmailAddress
        ) {
            emails += `;${this.contactInformation.selectedEmailAddress}`;
        }

        if (emails.length < 100) {
            canAdd = true;
        }

        this.lockEmailAddress = !canAdd;
        return canAdd;
    }

    preUpdateContactDetails() {
        this.switchEditContactDetails(true);
        this._toggleMultipleUnitsModal(this._hasMultipleUnits());
    }

    closeMultipleUnitChangeModal() {
        this.switchEditAddress(false);
        this.switchEditContactDetails(false);

        this.requestChangeForMultipleUnits();

        const $modal = this._toggleMultipleUnitsModal(false);
        $modal.on('hidden.bs.modal', () => {
            this.$timeout(() => {
                const $nextModal = angular.element('#multipleUnitChangeFinal');
                $nextModal.modal('show');
                $modal.off('hidden.bs.modal');
            }, 350);
        });
    }

    preSaveChanges() {
        const $modal = angular.element('#confirmationModal');
        $modal.modal('show');
    }

    async requestChangeForMultipleUnits() {
        const cardCode = this.selectedCardCode;

        try {
            this.ProfileService.requestChangeForMultipleUnits(cardCode);
        } catch (err) {
            this.NotificationService.error('ERROR REQUESTING CHANGE.');
        } finally {
        }
    }

    async updateContactDetails() {
        this.isBusy = true;

        const {
            HomeNumber,
            WorkNumber,
            EmailAddress,
            CellPhoneNumber
        } = this.contactInformation;

        const user = this.LocalStorageService.retrieve('userProfile');
        const { UserName } = user;

        const payload = {
            UserName,
            HomeNumber,
            WorkNumber,
            EmailAddress,
            CellPhoneNumber,
            EmailUserName: UserName,
            RegisteredName: UserName,
            CardCode: this.selectedUnitCardCard,
            CellPhoneNumberUserName: CellPhoneNumber[0]
        };

        try {
            await this.ProfileService.updateContactDetails(payload);
            await this.getMyProfileInformation();
            this.NotificationService.success('UPDATED DETAILS SUCCESSFULLY.');
        } catch (err) {
            this.NotificationService.error('UPDATING CONTACT DETAILS FAILED.');
        } finally {
            this.switchEditContactDetails(false);
            this.isBusy = false;
        }
    }

    _hasMultipleUnits() {
        let hasMultipleUnits = this.unitList.length > 1;
    }

    preUpdateAddressDetails() {
        this.switchEditAddress(true);
        this._toggleMultipleUnitsModal(this._hasMultipleUnits());
    }

    _toggleMultipleUnitsModal(shouldShow) {
        const $modal = angular.element('#multipleUnitChange');

        if (!shouldShow) {
            $modal.modal('hide');
        } else {
            $modal.modal('show');
        }

        return $modal;
    }

    async updateAddressDetails() {
        this.isBusy = true;

        try {
            const additionalInfo = {
                CardCode: this.selectedUnitCardCard,
                RegisteredName: this.LocalStorageService.retrieve('userProfile')
                    .UserName
            };

            this.addressInformation = {
                ...this.addressInformation,
                ...additionalInfo
            };

            const results = await this.ProfileService.updateAddressDetails(
                this.addressInformation
            );
            if (!results) {
                await this.getMyProfileInformation();
                this.NotificationService.success(
                    'UPDATED ADDRESS INFORMATION SUCCESSFULLY.'
                );
            } else {
                this.NotificationService.error('UPDATING ADDRESS INFORMATION FAILED.');
            }

            this.getMyProfileInformation();
        } catch (error) {
            this.NotificationService.error('UPDATING ADDRESS INFORMATION FAILED.');
        } finally {
            this.switchEditAddress(false);
            this.isBusy = false;
        }
    }

    async getMyProfileInformation() {
        this.isBusy = true;

        let selectedBuildingRefObj = this.selectedCardCode;

        try {
            if (
                !!selectedBuildingRefObj &&
                typeof selectedBuildingRefObj === 'string' &&
                selectedBuildingRefObj.includes('{')
            ) {
                selectedBuildingRefObj = JSON.parse(selectedBuildingRefObj);
            } else if (typeof selectedBuildingRefObj !== 'object') {
                selectedBuildingRefObj = await this.getSelectedUnit();
            }
            await this.ProfileService.getMyProfileInformation(selectedBuildingRefObj);
            this._setProfileInfo();
        } catch (error) {
            console.error(`Error while loading 'User Profile Details':\n${error}`);
            this.NotificationService.error('COULD NOT LOAD PROFILE');
        } finally {
            this.isBusy = false;
        }
    }

    async getSelectedUnit() {
        let selectedUnit;
        const units = await this.UserUnitsService.getFriendlyUnitNames();

        if (units) {
            let selectedCardCode = this.selectedCardCode;
            if (typeof selectedCardCode === 'object') {
                selectedCardCode = this.selectedCardCode.CardCode;
            }
            selectedUnit = units.find(
                unit => this.selectedCardCode === unit.CardCode
            );
        }

        return selectedUnit;
    }

    get selectedUnitCardCard() {
        const selectedCardCode = this.unitList.find(unit => {
            const { CardCode: cardCode } = unit;
            this.CardCode = cardCode;
        });

        const { CardCode } = selectedCardCode;

        return CardCode;
    }
    get selectedUnit() {
        if (this.unitList && this.unitList.length > 0) {
            let fullName;
            const selectedCardCode = this.unitList.find(
                unit => unit.CardCode === this.selectedCardCode
            );

            if (!!selectedCardCode) {
                const { FullName } = selectedCardCode;

                fullName = FullName;
            } else {
                fullName = '';
            }

            return fullName;
        } else {
            return '';
        }
    }

    get selectedBuilding() {
        let currentBuilding;
        let buildingRef = this.LocalStorageService.retrieve('selectedBuildingRef');
        if (!!buildingRef) {
            if (typeof buildingRef === 'string') {
                const user = this.LocalStorageService.retrieve('userProfile');
                const { BuildingProfiles: buildingProfiles } = user;

                const building = buildingProfiles.find(building => {
                    const { SchemeReference: schemeRef } = building;
                    const found = schemeRef === buildingRef;
                    return found;
                });

                if (!!building) {
                    currentBuilding = building;
                }
            } else {
                currentBuilding = buildingRef;
            }
        } else {
            const user = this.LocalStorageService.retrieve('userProfile');
            const { BuildingProfiles: buildingProfiles } = user;

            const building = buildingProfiles[0];

            if (!!building) {
                const { SchemeReference: schemeRef } = building;
                currentBuilding = building;
            }
        }

        return currentBuilding;
    }

    cancelEdit() {
        this.isEditingDetails = false;
        if (this.originalProfile) {
            this.ProfileService.myProfileInformation = angular.copy(this.originalProfile);
            this.originalProfile = null;
        }
    }

    showTrustee_chairmanModal() {
        const currentFirstEmail = this.ProfileService.myProfileInformation.EmailAddress[0];
        const firstEmailChanged = (currentFirstEmail ? currentFirstEmail.toLowerCase() : '') !==
            (this.originalFirstEmail ? this.originalFirstEmail.toLowerCase() : '');

        if (firstEmailChanged) {
            $("#chairman_trustee_modal").modal('show');
        } else {
            $("#confirmUpdatemodal").modal('show');
        }
    }
}
